import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import * as keyword from './types';

const mutations = {
  [keyword.SET_BENEFITS](state, benefits) {
    state.benefits = benefits;
  },
  [keyword.SET_BENEFIT](state, benefit) {
    state.benefit = benefit;
  },
  [keyword.SET_SECTIONS](state, sections) {
    let startIdx = sections.pagination.startReverseIndex;
    const newData = sections.content.reduce((p, c) => {
      c.idx = startIdx--;
      p.push(c);
      return p;
    }, []);
    sections.content = newData;
    state.sections = sections;
  },
  [keyword.SET_SECTION](state, section) {
    state.section = section;
  },
  [keyword.SET_SECTIONS_AREA](state, sections) {
    state.sections = sections;
  },
  [keyword.SET_STORES](state, stores) {
    state.stores = stores;
  },
  [keyword.SET_STORE](state, store) {
    state.store = store;
  },
  [keyword.RESET_BENEFIT](state) {
    state.benefits = {};
    state.benefit = {};
  },
  [keyword.RESET_SECTION](state) {
    state.sections = {};
    state.section = {};
  },
  [keyword.RESET_STORE](state) {
    state.stores = {};
    state.store = {};
  },
  [keyword.SET_TEMP_KEYWORDBENEFIT](state, data) {
    state.keywordBenefit = data;
  },
  [keyword.RESET_TEMP_KEYWORDBENEFIT](state) {
    state.keywordBenefit = {
      deviceIdx: '',
      deviceName: '',
      factoryPrice: '',
      keywordBenefitId: 0,
      keywordId: 0,
      manufacturerId: '',
      manufacturerName: '',
      modelName: '',
      period: '', //DAY_7 DAY_30
      storeId: 0,
    };
  },
  [keyword.SET_STOREKEYWORD](state, storeKeyword) {
    state.storeKeyword = storeKeyword;
  },
};

export default mutations;
